import { PopularContentItemProps } from '@components/report/content-items/popular-content-item/PopularContentItem';

import { IGContentData, IGReportRes } from '@apis/orval/model';

import { PopularContentProps } from './PopularContent';

export class PopularContentAdapter {
	value: IGReportRes;
	constructor(obj: IGReportRes) {
		this.value = obj;
	}

	get popularContents() {
		return this.value?.content?.recent_popular_contents ?? [];
	}

	outLink?: string;
	imgSrc?: string;
	hashTag?: string;
	likeCount?: number;
	commentCount?: number;

	sortContents(contents: IGContentData[], sortBy: 'newest' | 'engagement') {
		if (sortBy === 'newest')
			return contents.sort(
				(a, b) =>
					new Date(b.upload_at ?? 0).getTime() - new Date(a.upload_at ?? 0).getTime(),
			);
		else if (sortBy === 'engagement')
			return contents.sort(
				(a, b) =>
					(b.like_count ?? 0) +
					(b.comment_count ?? 0) -
					(a.like_count ?? 0 + (a.comment_count ?? 0)),
			);

		return contents;
	}

	getFeedContentItemProps(popularContentData: IGContentData): PopularContentItemProps {
		return {
			outLink: popularContentData.content_link ?? undefined,
			imgSrc: popularContentData.content_img_link ?? undefined,
			hashTag: popularContentData.search_hashtag ?? undefined,
			likeCount: popularContentData.like_count ?? undefined,
			commentCount: popularContentData.comment_count ?? undefined,
			isLikeHidden: !!(
				popularContentData.is_like_count_private ||
				(popularContentData?.like_count && popularContentData?.like_count < 0)
			),
			isCommentHidden: !!(
				popularContentData.is_comment_count_private ||
				(popularContentData?.comment_count && popularContentData?.comment_count < 0)
			),
		};
	}

	adapt(sortBy: 'newest' | 'engagement'): PopularContentProps {
		return {
			items: this.sortContents(this.popularContents, sortBy).map((popularContentData) =>
				this.getFeedContentItemProps(popularContentData),
			),
		};
	}
}
